import * as React from 'react'
import { dispatchToProps, IPhoneLinesListContainerProps } from './PhoneLinesList.container'
import { Table, TableHeader, TableRow } from 'features/Table'
import Pagination from 'components/Pagination'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import Button from 'components/Button'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import SelectPretty from 'components/Input/SelectPretty'
import * as sMarg from 'styles/modules/margins.scss'
import { Field } from 'redux-form'
import { Row, Col } from 'components/Layout'
import { Input } from 'components/Input/Input'
import { useGetPhoneLinesServicesQuery } from 'src/generated/graphql'
import useUnmount from 'react-use/lib/useUnmount'

export interface IPhoneLinesListComponentProps extends IPhoneLinesListContainerProps {
  replace: typeof dispatchToProps.replace
  banOptions: any
}

const typeOptions = [
  {
    name: 'Any',
    value: '',
  },
  {
    name: 'SIP Trunk',
    value: 'SIP Trunk',
  },
  {
    name: 'Telstra Phone',
    value: 'Telstra Phone',
  },
  {
    name: 'nbn Fibre Phone',
    value: 'nbn Fibre Phone',
  },
  {
    name: 'Telstra (GSM)',
    value: 'Telstra (GSM)',
  },
  {
    name: 'Number Range',
    value: 'Number Range',
  },
]

export const PhoneLinesListComponent = (props: IPhoneLinesListComponentProps) => {
  const { page, replace, banOptions, type, ban, search } = props
  const searchTimeoutRef = React.useRef<any>(undefined)

  const selectBan = (ban: string) => {
    replace({
      pathname: '/dashboard/phone-lines',
      query: { ban, type, search, page: 1 },
    })
  }
  const selectType = (type: string) => {
    replace({
      pathname: '/dashboard/phone-lines',
      query: { ban, type, search, page: 1 },
    })
  }
  const onSearchChange = (search: string) => {
    // if we still entering search term, cancel previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    // in order to minify number of API requests
    // and give user enough time to enter a search term,
    // we postpone requesting a little bit
    searchTimeoutRef.current = setTimeout(() => {
      replace({
        pathname: '/dashboard/phone-lines',
        query: { ban, type, search, page: 1 },
      })
    }, 300)
  }

  useUnmount(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }
  })
  const { data, loading } = useGetPhoneLinesServicesQuery({
    variables: { page, ban, type: type ? [type] : undefined, search },
  })

  if (loading || !data) return <LoadingOverlay transparent />
  const { results, totalPages } = data.phoneLines
  return (
    <div>
      <Row
        className={cn(
          sMarg.mb30,
          sLay['layout-gt-xs-column'],
          sLay['layout-gt-xs-row'],
          sLay['layout-align-end'],
          'sm'
        )}
      >
        <Col className={cn('sm', sMarg.mb15xs)}>
          <Field
            component={props => <Input label="Search" hideDot display="box" {...props} />}
            name="search"
            onChange={event => onSearchChange(event ? event.target.value : '')}
          />
        </Col>
        <Col className={cn('sm', sMarg.mb15xs)}>
          <Field
            label="Billing Account"
            component={SelectPretty}
            name="ban"
            options={banOptions}
            display="box"
            onChangeAlt={selectBan}
          />
        </Col>
        <Col className={cn('sm')}>
          <Field
            label="Type"
            component={SelectPretty}
            name="type"
            options={typeOptions}
            display="box"
            onChangeAlt={selectType}
          />
        </Col>
      </Row>
      {results.length === 0 ? (
        <EmptyMessageCard
          title="You have no phone lines"
          subtitle="Give us a call to find out more"
        />
      ) : (
        <div>
          <Table
            header={
              <TableHeader>
                <div>Number</div>
                <div>Service Type</div>
                <div className={sLay['hide-xs']}>Reference</div>
                <div className={sLay['hide-xs']}>Current Status</div>
                <div className={cn(sLay['hide-xs'], sLay['hide-sm'])}>Line Details</div>
                <div style={{ maxWidth: '76px' }} />
              </TableHeader>
            }
          >
            {results.map(service => {
              return (
                <TableRow key={service.id}>
                  <div>{service.number}</div>
                  <div>{service.serviceType}</div>
                  <div>{service.customerReference}</div>
                  <div className={sLay['hide-xs']}>{service.currentStatus}</div>
                  <div className={cn(sLay['hide-xs'], sLay['hide-sm'])}>{service.cpeType}</div>
                  <div style={{ maxWidth: '76px' }}>
                    <Button
                      color="tertiary"
                      size="xs"
                      ghost
                      to={`/dashboard/phone-lines/${service.id}`}
                    >
                      View
                    </Button>
                  </div>
                </TableRow>
              )
            })}
          </Table>
        </div>
      )}
      <Pagination
        page={page}
        numPages={totalPages}
        onClick={nextPage =>
          replace({
            pathname: location.pathname,
            query: {
              ban,
              type,
              page: nextPage,
            },
          })
        }
      />
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneLines/PhoneLinesList/PhoneLinesList.tsx